export default {"src":"/_next/static/media/WhoWeAre_028A.2e5fbcf4.JPG","height":692,"width":1920};